import Vue from "vue";
import "./shared";
import "./mixins";
import DatetimePicker from 'vuetify-datetime-picker'

import "./permission";
import "@/assets/scss/main.scss";
import "@/api";
import VueMoment from 'vue-moment';
import moment from 'moment';

// Configure Vue to use VueMoment
Vue.use(VueMoment, { moment });



Vue.use(DatetimePicker);
import ToggleService from "@/components/ToggleService";
Vue.component("toggle-service", ToggleService);
Vue.prototype.$eventBus = new Vue();
